import { render } from "./TableButtonDelete.vue?vue&type=template&id=131b0622"
import script from "./TableButtonDelete.vue?vue&type=script&lang=js"
export * from "./TableButtonDelete.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__